module.exports = __webpack_public_path__ + "img/WI2000.ed089282.jpg";